import { ApplicationView, useController } from "@mixitone/mvc";
import { isNil } from "@mixitone/util";
import { Toggle } from "../Controls/Form/Toggle";
import { useState } from "react";
import { TableController } from "./TableController";

const UncontrolledToggleHeader: React.FC<{ label: string; filterKey: string }> = ({ label, filterKey }) => {
  const controller = useController(TableController<any, { [key: string]: any }>);
  const filterValue = controller.state.filters[filterKey];
  const [active, setActive] = useState(!isNil(filterValue));
  const [value, setValue] = useState(filterValue === true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.indeterminate) {
      setActive(false);
      setValue(false);
    } else {
      setActive(true);
      setValue(e.target.checked);
    }

    controller.actionSetFilter(filterKey, e.target.checked ? true : e.target.indeterminate ? null : false);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <span className="text-sm">{label}</span>
      <Toggle small checked={value} allowIndeterminate indeterminate={!active} onChange={handleChange} />
    </div>
  );
};

const ToggleHeader = ApplicationView(UncontrolledToggleHeader);

export { ToggleHeader };
